// Chose one of the starting points to import

// ==============================================
// Postcss + tailwind
// ==============================================
import "../styles/css/site.css"
import "../styles/css/formie.css"


// Vendor imports
import "alpinejs"
import Alpine from "alpinejs"
import persist from '@alpinejs/persist'
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse'
window.Alpine = Alpine
Alpine.plugin(persist)
Alpine.plugin(collapse)
Alpine.plugin(focus)
window.Alpine.start()

//Animation AOS JS
import AOS from "aos"
// You can also use <link> for styles
// ..
AOS.init()

import "lazysizes/plugins/respimg/ls.respimg"
import "lazysizes/plugins/parent-fit/ls.parent-fit"
import "lazysizes"
import "lazysizes/plugins/object-fit/ls.object-fit"

import { Fancybox } from "@fancyapps/ui"

// import objectFitVideos from "object-fit-videos"
// objectFitVideos()

// Module imports
import "./modules/alerts"
import "./modules/filters"
import "./modules/svgIconSprite"
import "./modules/carousel"
import "./modules/googleMaps"
import "./modules/formieEvents"
import "./modules/aosPopup"

// import "./blocks/brushingTips"

// googleMaps still requires jQuery, and needs to be refactored
// import "./modules/googleMaps"

/**
 * Accept hot reloading from dev server
 * Without this you may see this warning in your console:
 * "[HMR] Cannot apply update. Need to do a full reload!"
 */
// if (module.hot) module.hot.accept()

// Scroll To Top Button show hide

let scrollButton = document.querySelector("#scrollButton")
scrollButton.classList.add("opacity-0")

window.addEventListener("scroll", () => {
	let scrollY = window.scrollY
	if (scrollY > 600) {
		scrollButton.classList.remove("opacity-0")
	} else {
		scrollButton.classList.add("opacity-0")
	}
})
